// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { store } from './store/store'
import Buefy from 'buefy'
import VueLodash from 'vue-lodash'
// import 'buefy/lib/buefy.css'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'

Vue.use(Buefy)
Vue.use(VueAxios, axios)
Vue.use(VueLodash)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1000
})
const isProd = process.env.NODE_ENV === 'production'
Vue.use(VueAnalytics, {
  id: 'UA-36468375-2',
  router,
  debug: {
    enabled: !isProd,
    sendHitTaslk: isProd
  }
})
// global event bus
// let eventHub = new Vue()
export const eventHub = new Vue()
Vue.prototype.$eventHub = eventHub

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store: store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js